import { PropertyType } from 'esa-ui-library/lib/types';
import { api, setConfig } from '../..';

export const getDashboard = (data: PropertyType): Promise<PropertyType> =>
	api.get(`/dashboard${data?.query}`, setConfig(data)).then((res) => {
		return res.data;
	});
